import { cn } from './ui/utils';

type StageFlowLogoProps = {
  className?: string;
  /** 'compact' swaps in the reduced-detail mark that stays readable below ~24px. */
  variant?: 'full' | 'compact';
  /** Set this when no adjacent "StageFlow" text already names the app. */
  alt?: string;
};

// The StageFlow brand mark. It's referenced as a file rather than inlined so
// every placement shares one asset with the favicon and PWA icons — and so two
// marks on the same page can't collide on the artwork's gradient ids.
//
// The artwork carries its own rounded-square container, so callers only set a
// size: no background or padding wrapper needed.
export function StageFlowLogo({ className, variant = 'full', alt = '' }: StageFlowLogoProps) {
  return (
    <img
      src={variant === 'compact' ? '/favicon.svg' : '/logo.svg'}
      alt={alt}
      aria-hidden={alt ? undefined : true}
      draggable={false}
      className={cn('shrink-0 select-none object-contain', className)}
    />
  );
}
